import ShortCutDisplay from "../../../../src/components/ShortcutDisplay";
import PolypaneIntro from "../../../../src/components/PolypaneIntro";
import ThanksCallout from "../../../../src/components/ThanksCallout";
import resourcebadge from "../../../../assets/images/docs/resources/badges.png";
import crash from "../../../../assets/images/blogs/pp31/crash.png";
import pagezooms from "../../../../assets/images/blogs/pp31/pagezooms.png";
import browsezoom from "../../../../assets/images/blogs/pp31/browsezoom.png";
import browsenotifs from "../../../../assets/images/blogs/pp31/browsenotifs.png";
import iphoneduo from "../../../../assets/images/blogs/pp31/iphoneduo.png";
import propref from "../../../../assets/videos/blogs/pp31/propref.mp4";
import canvasintro from "../../../../assets/videos/blogs/pp31/canvasintro.mp4";
import canvasdraw from "../../../../assets/videos/blogs/pp31/canvasdraw.mp4";
import scrollbadge from "../../../../assets/videos/blogs/pp31/scrollbadge.mp4";
import domsearch from "../../../../assets/images/docs/elements/domsearch.png";
import flex2 from "../../../../assets/images/blogs/pp31/flex2.png";
import flexitem from "../../../../assets/images/docs/elements/flexitem.png";
import minimap from "../../../../assets/images/docs/layouts/minimap.png";
import stylepanel from "../../../../assets/images/docs/elements/style.png";
import * as React from 'react';
export default {
  ShortCutDisplay,
  PolypaneIntro,
  ThanksCallout,
  resourcebadge,
  crash,
  pagezooms,
  browsezoom,
  browsenotifs,
  iphoneduo,
  propref,
  canvasintro,
  canvasdraw,
  scrollbadge,
  domsearch,
  flex2,
  flexitem,
  minimap,
  stylepanel,
  React
};